export default "__VITE_ASSET__maQweLdn__"